import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { IDateRangePicker } from '../date-range-picker/date-range-picker.component';
import { IAngularMyDpOptions, IMyDateModel } from '@nodro7/angular-mydatepicker';
import moment from 'moment';
import * as _ from 'lodash';

@Component({
    selector: 'app-date-range-picker-custom',
    templateUrl: './date-range-picker-custom.component.html',
})
export class DateRangePickerCustomComponent {
    @Input() model: IDateRangePicker;
    myDpOptionsFrom: IAngularMyDpOptions = {
        dateRange: false,
        dateFormat: 'dd/mm/yyyy',
        stylesData: {
            selector: 'dp1',
            styles: `
                .dp1 .myDpDimDay {
                    opacity:0.7;
                }
               .dp1 .myDpIconLeftArrow,
               .dp1 .myDpIconRightArrow,
               .dp1 .myDpHeaderBtn {
                   color: #0A123A;
                }
               .dp1 .myDpHeaderBtn:focus,
               .dp1 .myDpMonthLabel:focus,
               .dp1 .myDpYearLabel:focus {
                   color: #1c2862;
                }
               .dp1 .myDpDaycell:focus,
               .dp1 .myDpMonthcell:focus,
               .dp1 .myDpYearcell:focus {
                   box-shadow: inset 0 0 0 1px #1c2862;
                }
               .dp1 .myDpSelector:focus {
                   box-shadow: -1px 1px 6px 0px #1c2862;
                }
               .dp1 .myDpSelectorArrow:focus:before {
                   border-bottom-color: #1c2862;
                }
               .dp1 .myDpCurrMonth,
               .dp1 .myDpMonthcell,
               .dp1 .myDpYearcell {
                   color: #0A123A;
                }
               .dp1 .myDpDaycellWeekNbr {
                   color: #0A123A;
                }
               .dp1 .myDpPrevMonth,
               .dp1 .myDpNextMonth {
                   color: #6495ED;
                }
               .dp1 .myDpWeekDayTitle {
                   background-color: transparent;
                   color: #0A123A;
                   font-weight: bold;
                }
               .dp1 .myDpHeaderBtnEnabled:hover,
               .dp1 .myDpMonthLabel:hover,
               .dp1 .myDpYearLabel:hover,
               .dp1 .myDpFooterBtn:hover {
                   color: #1c2862;
                }
               .dp1 .myDpMarkCurrDay,
               .dp1 .myDpMarkCurrMonth,
               .dp1 .myDpMarkCurrYear {
                   border-bottom: 2px solid #ccc;
                }
               .dp1 .myDpDisabled {
                   color: #999;
                }
               .dp1 .myDpHighlight {
                   color: #f00;
                }
               .dp1 .myDpTableSingleDay:hover,
               .dp1 .myDpTableSingleMonth:hover,
               .dp1 .myDpTableSingleYear:hover {
                   background-color: #0A123A;
                   color: #ffffff;
                }
               .dp1 .myDpRangeColor {
                   background-color: #4252a5;
                   color: #fff;
                   font-weight: bold;
                }
               .dp1 .myDpSelectedDay,
               .dp1 .myDpSelectedMonth,
               .dp1 .myDpSelectedYear {
                   background-color: #0A123A;
                   color: #fff;
                   font-weight: bold;
                }
             `,
        },
    };
    myDpOptionsTo: IAngularMyDpOptions = _.cloneDeep(this.myDpOptionsFrom);

    @Output() modelChange: EventEmitter<IDateRangePicker> = new EventEmitter();
    myDpModelFrom: IMyDateModel;
    myDpModelTo: IMyDateModel;
    @ViewChild('dpFrom', { static: true }) dpFrom: any;
    @ViewChild('dpTo', { static: true }) dpTo: any;

    cdRef = inject(ChangeDetectorRef);

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.model && changes.model.currentValue) {
            this.model = changes.model.currentValue;
            this.fromModelToMyDpModel();
        }
    }

    fromModelToMyDpModel() {
        this.myDpModelFrom = {
            isRange: false,
            singleDate: { jsDate: moment(this.model.from).toDate() },
        };
        this.myDpModelTo = {
            isRange: false,
            singleDate: { jsDate: moment(this.model.to).toDate() },
        };
    }

    onMyDpModelFromChange() {
        if (!this.myDpModelFrom) {
            this.model = {
                ...this.model,
                from: null,
            };
        } else {
            const fromParts = this.myDpModelFrom.singleDate.formatted.slice(0, 10).split('/');
            if (fromParts.length === 3) {
                this.model.from = fromParts[2] + '-' + fromParts[1] + '-' + fromParts[0];
            }
        }
        if (this.model.from > this.model.to) {
            this.dpTo.clearDate();
        }
        this.modelChange.emit(this.model);
        this.dpTo.openCalendar();
    }

    onMyDpModelToChange() {
        if (!this.myDpModelTo) {
            this.model = {
                ...this.model,
                to: null,
            };
        } else {
            const toParts = this.myDpModelTo.singleDate.formatted.slice(0, 10).split('/');
            if (toParts.length === 3) {
                const to = toParts[2] + '-' + toParts[1] + '-' + toParts[0];
                if (to >= this.model.from) {
                    this.model.to = to;
                } else {
                    this.model.from = to;
                    this.model.to = null;
                    this.dpTo.clearDate();
                }
            }
        }
        this.fromModelToMyDpModel();
        this.modelChange.emit(this.model);
    }
}
